// extracted by mini-css-extract-plugin
export default {"fr-view":"ImageContainer_fr-view__keyAR","container":"ImageContainer_container__f2ThJ","wrapper":"ImageContainer_wrapper__uHVNT","image":"ImageContainer_image__7IV6J"};